<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">                
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="ruleName" label="规则名称">
                        <el-input v-model="formData.ruleName" placeholder="请输入规则名称" maxlength="80" size="medium"/>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="停发地区" prop="code">
                        <el-select
                            v-model="formData.code"
                            multiple
                            filterable
                            placeholder="选择省份，支持选择多个省份"
                            style="width: 100%"
                            size="medium">
                            <el-option
                                v-for="item in provinceOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="goodsType" label="适用商品">
                        <el-radio-group v-model="formData.goodsType">
                            <el-radio :label="1">部分商品</el-radio>
                            <el-radio :label="2">全部商品</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="formData.goodsType == 1">
                        <el-form-item prop="goodsIds">
                            <el-input type="textarea"  v-model="formData.goodsIds" maxlength="5000" placeholder="多个商品ID以英文逗号分隔"></el-input>
                        </el-form-item>
                    </template>                    
                </el-col>
            </el-row>
            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {fetchProvince} from '@/assets/js/commonApi'
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        const validateBindIds = async (rule, value, callback) => {
            if(!value) return callback(new Error('请至少输入1个适用商品ID'));
            if(!/^[0-9,]+$/.test(value)) return callback(new Error('请输入正确的格式'));
            return callback();
        };
        return {
            formData: {
                ruleName: '',
                goodsType: 1,
                goodsIds: '',
                code: []
            },
            rules: {
                ruleName: [{ required: true, message: "请输入规则名称" }],
                goodsType: [{ required: true, message: "请选择适用商品类型"}],
                goodsIds:[{ validator: validateBindIds}],
                code: [{ required: true, message: "请添加至少一个地区"}]
            },
            provinceOptions: [],
            btnLoading: false,
            pageLoading: false,
            selectLoading: false,
            redirect: this.$route.query.redirect || '/goodsManage/logistics/list'
        };
    },
    created() {
        if (this.id) {
            this.getData();
        }
        this.remoteMethod();
    },
    methods: {        
        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/logistics/rule/detail",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    // this.provinceOptions = result.disabledProvinces;
                    this.$nextTick(()=>{                        
                        this.formData = Object.assign(this.formData, result);
                        result.disabledProvinces.map(i => {
                            this.formData.code.push(i.id);
                        });
                    })                    
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const url = !this.id ? "/logistics/rule/create" : "/logistics/rule/update";
                    const data = {...this.formData};
                    data.disabledArea = data.code.join();
                    if(this.formData.goodsType == 2){
                        data.goodsIds = '';
                    }
                    this.$request({
                        url,
                        method: "POST",
                        data,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        // 省份搜索
        remoteMethod(){
            fetchProvince().then((res) => {
                const { state, result } = res.data;
                if (state && state == 1) {
                    this.provinceOptions = result;
                }
            })
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
    },
};
</script>
